import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {updateStepData} from "../../redux/actions/actions";
import {ButtonContainer} from "../ButtonContainer/ButtonContainer";

const STEP_NUMBER = 2;
export const UsualSizeSlide = ({nextStep, prevStep}) => {
    const stepData = useSelector(state => state.stepsData.filter(stepData => stepData.stepNumber === STEP_NUMBER)[0]);
    const dispatch = useDispatch();
    const onChange = (e) => {
        const newStepData = {...stepData};
        newStepData.inputValue = e.target.value;
        dispatch(updateStepData(STEP_NUMBER, newStepData));
    };

    const showNextButton = () => stepData.inputValue !== "";
    return (
        <div className="usualSize">
            <div className="fadeIn">
                <h1>Размер, который Вы обычно носите:</h1>
                <p>Введите в любом удобном виде:</p>
                <input onChange={onChange} value={stepData.inputValue}/>
            </div>
            <ButtonContainer prevStep={prevStep} nextStep={nextStep} showNextButton={showNextButton()} disableNextButton={false}/>
        </div>
    )
};
